import {
  BmkAtcTpCd,
  BookmarkCondition,
  BookmarkDtail,
  BookmarkMaster,
} from 'models/common/Bookmark';
import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import { MyBookmarkDtl } from '../../models/admin/MyBookmark';

/**
 * 나의 관심 항목 조회
 */
export const findBookmark = async (bmkAtcTpCd: BmkAtcTpCd) => {
  const condition = {
    bmkAtcTpCd: bmkAtcTpCd,
  } as BookmarkCondition;

  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/bookmark`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<BookmarkMaster[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as BookmarkMaster[];
};

/**
 * 나의 관심 항목 저장(검색조건)
 *
 */
export const saveCondBookmarks = async (master: BookmarkMaster) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/cond-bookmark`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: master,
  };
  const response: CommonResponse = await callApi(request);
  return response;
};

/**
 * 나의 관심 항목 조회(검색조건)
 *
 */
export const getCondBookmarks = async (condition: BookmarkCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/cond-bookmark`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };
  const response: CommonResponse<BookmarkDtail[]> = await callApi(request);
  return response;
};

/**
 * 그리드 필드 숨김 적용 저장
 * @param mnuUrl    메뉴 URL
 * @param gridId    그리드ID
 * @param details   북마크 상세 목록 (노출할 필드 목록)
 */
export const saveGridField = async (mnuUrl = '', gridId = '', details?: BookmarkDtail[]) => {
  const master = {
    bmkGrDesc: mnuUrl,
    bmkAtcTpCd: gridId,
    detailList: details,
  } as BookmarkMaster;
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/bookmark/grid-field`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: master,
  };
  const response: CommonResponse = await callApi(request);
  return response;
};

/**
 * 그리드 필드 숨김 적용 조회
 *
 * @param mnuUrl    메뉴 URL
 * @param gridId    그리드ID
 */
export const findGridField = async (mnuUrl = '', gridId = '') => {
  const condition = {
    bmkGrDesc: mnuUrl,
    bmkAtcTpCd: gridId,
  } as BookmarkCondition;

  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/bookmark/grid-field`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };
  const response: CommonResponse<BookmarkDtail[]> = await callApi(request);
  return response;
};
